export const CONSTS = {
  FROM_LABEL: $localize`From`,
  TO_LABEL: $localize`To`,
};
